import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useAuthStore } from "@/stores/auth";
import { useBootstrapStore } from "@/stores/bootstrap";
import {
  NO_LINE_AUTH_PATHS,
  FREE_FROM_BOOTSTRAP_PATHS,
  matchesPath,
} from "@/utils/authPaths";

export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    return;
  }
  
  // 1. กันหน้า no-login จาก login policy (ข้อ 2-5) ในทุก navigation รวม client-side
  // plugin: plugin เช็ก path เพื่อตัดสิน init ตอนบูตครั้งเดียว แต่ middleware คุม navigation policy ทุกครั้ง
  if (matchesPath(NO_LINE_AUTH_PATHS, to.path)){
    return;
  }
  
  
  const auth = useAuthStore();

  // 2. รอ plugin init LIFF ให้เสร็จก่อน
  // ปกติ plugin (00.liff.client.ts) รัน async จบก่อน middleware อยู่แล้ว isReady จึงเป็น true
  // (แม้ init จะ error plugin ก็ set isReady = true ใน finally) — ถ้ายังไม่ ready ก็ยังตัดสินใจไม่ได้ ปล่อยผ่านไปก่อน
  if (!auth.isReady) {
    return;
  }

  // 3. เปิดผ่าน external browser แล้วยังไม่ได้ login → เด้งไป LINE OAuth (กลับมาที่หน้าเดิมหลัง login)
  // ส่วน LINE in-client ถ้า isLoggedIn = false แปลว่า user ปฏิเสธ permission เอง — ไม่เด้งซ้ำ ปล่อยให้หน้าจัดการ
  if (!auth.isLoggedIn && !auth.isInClient) {
    auth.login(window.location.origin + to.fullPath);
    return;
  }

   // 4. Login LINE แล้ว แต่หน้านี้ยังไม่ต้องมี user record ใน Firestore (หน้าลงทะเบียน/invite ฯลฯ) → ผ่านได้เลย
  if (matchesPath(FREE_FROM_BOOTSTRAP_PATHS, to.path)) {
    return;
  }

  // 5. /v3/* ต้องผ่าน bootstrap แล้วเท่านั้น (ต้องมี user record)
  if (to.path.startsWith("/v3")) {
    const bootstrap = useBootstrapStore();
    if (!bootstrap.isInit) {
      return navigateTo("/");
    }
  }
});
